import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-success.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const SuccessIcon = createSvgIcon(<Icon />, 'SuccessIcon');
